import { css } from 'aphrodite';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { Checkbox } from '../../../../web/components-v2/Checkbox';
import {
	Dialog,
	DialogBody,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../../web/components-v2/Dialog';
import { Label } from '../../../../web/components-v2/Label';
import { ISelectOption } from '../../../../web/components/DeprecatedSelect';
import { styleSheet } from '../styles';
import { weekDays } from '../utils';
import { TimeRangeRepeater } from './TimeRangeRepeater';

export interface IRangeValues {
	start: ISelectOption<number>;
	end: ISelectOption<number>;
}

export interface IScheduleInterval {
	enabled: boolean;
	index: number;
	label: string;
	range?: IRangeValues[];
}

interface IProps {
	values: IScheduleInterval[];
	isOpen: boolean;
	onClickToClose: () => void;
	onClickToSave: (values: IScheduleInterval[]) => void;
}

export const ScheduleModal: React.FC<IProps> = ({ values, isOpen, onClickToClose, onClickToSave }) => {
	const [selectedSchedule, setSchedule] = useState<IScheduleInterval[]>(values || weekDays);

	useEffect(() => {
		if (values) {
			setSchedule(values);
		}
	}, [values]);

	const handleTimeRepeaterChanges = (index: number) => (value: { enabled?: boolean; range?: IRangeValues[] }) => {
		const prevState = [...selectedSchedule];
		const newState = prevState.map(item => {
			if (item.index === index) {
				item = { ...item, ...value };
			}
			return item;
		});
		setSchedule(newState);
	};

	const handleSaveSchedule = () => {
		onClickToSave?.(selectedSchedule);
	};

	const handleWeekdayState = (index: number) => (checked: boolean) => {
		handleTimeRepeaterChanges(index)({ enabled: checked });
	};

	const handleTimeRange = (index: number) => (range: IRangeValues[]) => {
		handleTimeRepeaterChanges(index)({ range });
	};

	const currentState = [...selectedSchedule];

	return (
		<Dialog open={isOpen} onOpenChange={open => !open && onClickToClose()}>
			<DialogPopup forceBackdrop>
				<DialogHeader>
					<DialogTitle>Set Schedule</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<div className={css(styleSheet.dialogColumn)}>
						{selectedSchedule.map(({ label, index }) => {
							const currentItem = currentState.filter(item => item.index === index)?.[0];
							return (
								<div key={label} className={css(styleSheet.dayRow)}>
									<div className={css(styleSheet.dayLabel)}>
										<Label htmlFor={`checkbox-${label}-${index}`}>
											<Checkbox
												id={`checkbox-${label}-${index}`}
												checked={!!currentItem?.enabled}
												onCheckedChange={handleWeekdayState(index)}
											/>
											{label}
										</Label>
									</div>
									<TimeRangeRepeater
										values={currentItem?.range}
										disabled={!currentItem?.enabled}
										onChange={handleTimeRange(index)}
										dayLabel={label}
									/>
								</div>
							);
						})}
					</div>
				</DialogBody>
				<DialogFooter>
					<Button onClick={handleSaveSchedule}>Update</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};
